import { calculateRequiredDonationAmount } from '@/app/donation/_utils/giftOrder';

interface CalculateGiftDonationAmountParams {
  currentPrice: number;
  extraProductPrices: number[];
  quantity: number;
  hasOptions: boolean;
}

//* 옵션 있는데 미선택이면 수량을 반영하지 않는다 — 옵션 선택 전에는 확정 금액이 아니기 때문
export const calculateGiftDonationAmount = ({
  currentPrice,
  extraProductPrices,
  quantity,
  hasOptions,
}: CalculateGiftDonationAmountParams) => {
  const totalExtraProductPrice = extraProductPrices.reduce(
    (accumulated, extraProductPrice) => accumulated + extraProductPrice,
    0,
  );
  const unitDonationAmount = calculateRequiredDonationAmount(
    currentPrice + totalExtraProductPrice,
  );

  if (hasOptions && extraProductPrices.length === 0) {
    return unitDonationAmount;
  }

  return unitDonationAmount * quantity;
};
